import type { ControlProps } from './types';

export const FONT_OPTIONS = [
  'Inter, system-ui, sans-serif',
  'Arial, Helvetica, sans-serif',
  'Helvetica Neue, Helvetica, sans-serif',
  'Georgia, serif',
  'Times New Roman, Times, serif',
  'Courier New, Courier, monospace',
  'Verdana, Geneva, sans-serif',
  'Trebuchet MS, sans-serif'
];

export function FontControl({ schema, value, disabled, onChange }: ControlProps) {
  const current = typeof value === 'string' ? value : '';
  return (
    <select
      aria-label={schema.label}
      value={current}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      {!FONT_OPTIONS.includes(current) && <option value={current}>{current}</option>}
      {FONT_OPTIONS.map((font) => (
        <option key={font} value={font} style={{ fontFamily: font }}>
          {font.split(',')[0]}
        </option>
      ))}
    </select>
  );
}
